import { render, staticRenderFns } from "./ElPostCategories.vue?vue&type=template&id=67d8cbb4"
import script from "./ElPostCategories.vue?vue&type=script&lang=js"
export * from "./ElPostCategories.vue?vue&type=script&lang=js"
import style0 from "./ElPostCategories.vue?vue&type=style&index=0&id=67d8cbb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports